import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import StringInput from 'components/field/StringInput';
import FormItem from 'components/form/FormItem';

import ActivateStore from '../Fields/ActivateStore';
import StoreName from '../Fields/StoreName';
import * as S from '../SalesChannel.styled';

const MiraklForm = () => {
	const {
		formState: { isSubmitting, isLoading: isFormLoading }
	} = useFormContext();
	const { t } = useTranslation();

	const isLoading = isSubmitting || isFormLoading;
	return (
		<S.StoreAccordion header="storeDetails" defaultVisible>
			<StoreName isLoading={isLoading} />
			<FormItem label="clientSecret" isLoading={isLoading} required>
				<StringInput name="secret" placeholder={t('fieldPlaceholder', { name: t(`clientSecret`) })} />
			</FormItem>
			<FormItem label="sellerCompanyId" isLoading={isLoading} required>
				<StringInput name="username" placeholder={t('fieldPlaceholder', { name: t(`sellerCompanyId`) })} />
			</FormItem>
			<FormItem label="clientID" isLoading={isLoading} required>
				<StringInput name="token" placeholder={t('fieldPlaceholder', { name: t(`clientId`) })} />
			</FormItem>

			<ActivateStore />
		</S.StoreAccordion>
	);
};

export default MiraklForm;
